var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "meeting-detail"
  }, [_vm.loading ? _c('a-spin', {
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "tip": "加载中..."
    }
  }) : _c('div', {
    staticClass: "detail-content"
  }, [_c('div', {
    staticClass: "detail-left"
  }, [_c('a-form', {
    attrs: {
      "model": _vm.detail,
      "layout": "vertical"
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("申请人信息")]), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "申请人"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.applicantName,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "applicantName", $$v);
      },
      expression: "detail.applicantName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "申请部门"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.department,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "department", $$v);
      },
      expression: "detail.department"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.contactPerson,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "contactPerson", $$v);
      },
      expression: "detail.contactPerson"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.contactPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "contactPhone", $$v);
      },
      expression: "detail.contactPhone"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("会议基本信息")]), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "会议主题"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.meetingName,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "meetingName", $$v);
      },
      expression: "detail.meetingName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "参会人数"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.attendeeCount,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "attendeeCount", $$v);
      },
      expression: "detail.attendeeCount"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "预约日期"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.reservationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "reservationDate", $$v);
      },
      expression: "detail.reservationDate"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "开始时间"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.startTime,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "startTime", $$v);
      },
      expression: "detail.startTime"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "结束时间"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.endTime,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "endTime", $$v);
      },
      expression: "detail.endTime"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("设备需求")]), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "checkbox-group"
  }, [_c('a-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needProjector,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needProjector", $$v);
      },
      expression: "detail.needProjector"
    }
  }, [_vm._v("投影/LED")]), _c('a-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needVideoConference,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needVideoConference", $$v);
      },
      expression: "detail.needVideoConference"
    }
  }, [_vm._v("视频会议系统")]), _c('a-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needMicrophone,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needMicrophone", $$v);
      },
      expression: "detail.needMicrophone"
    }
  }, [_vm._v("麦克风")])], 1)]), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "其他信息化设备"
    }
  }, [_c('a-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.detail.otherEquipment,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "otherEquipment", $$v);
      },
      expression: "detail.otherEquipment"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("服务需求")]), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "checkbox-group"
  }, [_c('a-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needFurniture,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needFurniture", $$v);
      },
      expression: "detail.needFurniture"
    }
  }, [_vm._v("桌椅布置")]), _c('a-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needWater,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needWater", $$v);
      },
      expression: "detail.needWater"
    }
  }, [_vm._v("订水")]), _c('a-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needTeaBreak,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needTeaBreak", $$v);
      },
      expression: "detail.needTeaBreak"
    }
  }, [_vm._v("茶歇")])], 1)])], 1)], 1), _c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("其他需求")]), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "信息技术支持"
    }
  }, [_c('a-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needTechSupport ? 'need' : 'none',
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needTechSupport ? 'need' : 'none'", $$v);
      },
      expression: "detail.needTechSupport ? 'need' : 'none'"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("无")]), _c('a-radio', {
    attrs: {
      "value": "need"
    }
  }, [_vm._v("有")])], 1)], 1), _vm.detail.needTechSupport ? _c('a-form-item', {
    attrs: {
      "label": "详细需求"
    }
  }, [_c('a-textarea', {
    attrs: {
      "readonly": "",
      "rows": 2
    },
    model: {
      value: _vm.detail.techSupportDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "techSupportDescription", $$v);
      },
      expression: "detail.techSupportDescription"
    }
  })], 1) : _vm._e()], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "安保需求/路线"
    }
  }, [_c('a-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.detail.needSecurity ? 'need' : 'none',
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "needSecurity ? 'need' : 'none'", $$v);
      },
      expression: "detail.needSecurity ? 'need' : 'none'"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("无")]), _c('a-radio', {
    attrs: {
      "value": "need"
    }
  }, [_vm._v("有")])], 1)], 1), _vm.detail.needSecurity ? _c('a-form-item', {
    attrs: {
      "label": "详细需求"
    }
  }, [_c('a-textarea', {
    attrs: {
      "readonly": "",
      "rows": 2
    },
    model: {
      value: _vm.detail.securityDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "securityDescription", $$v);
      },
      expression: "detail.securityDescription"
    }
  })], 1) : _vm._e()], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "会议说明"
    }
  }, [_c('a-textarea', {
    attrs: {
      "readonly": "",
      "rows": 3
    },
    model: {
      value: _vm.detail.meetingDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.detail, "meetingDescription", $$v);
      },
      expression: "detail.meetingDescription"
    }
  })], 1)], 1)], 1)], 1)])], 1), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "process-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("流程流转记录")]), _c('div', {
    staticClass: "process-timeline"
  }, [_vm.loading ? _c('a-spin', {
    staticStyle: {
      "display": "block",
      "text-align": "center",
      "padding": "20px 0"
    },
    attrs: {
      "tip": "加载中..."
    }
  }) : _c('div', [_c('div', {
    staticClass: "flow-item applicant-item"
  }, [_c('div', {
    staticClass: "flow-item-header"
  }, [_c('span', {
    staticClass: "flow-node-name"
  }, [_vm._v("提交申请")]), _c('a-tag', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("申请人")])], 1), _c('div', {
    staticClass: "flow-item-content"
  }, [_c('p', {
    staticClass: "flow-assignee"
  }, [_c('strong', [_vm._v("申请人：")]), _vm._v(_vm._s(_vm.detail.applicantName || '-'))]), _c('p', {
    staticClass: "flow-department"
  }, [_c('strong', [_vm._v("申请部门：")]), _vm._v(_vm._s(_vm.detail.department || '-'))]), _c('p', {
    staticClass: "flow-time-info"
  }, [_c('strong', [_vm._v("申请时间：")]), _vm._v(_vm._s(_vm.detail.createTime || '-'))])])]), _vm.detail.flowRecords && _vm.detail.flowRecords.length > 0 ? _c('div', {
    staticClass: "flow-line"
  }) : _vm._e(), _vm._l(_vm.detail.flowRecords, function (record, index) {
    return _c('div', {
      key: index,
      staticClass: "flow-item"
    }, [_c('div', {
      staticClass: "flow-item-header"
    }, [_c('span', {
      staticClass: "flow-node-name"
    }, [_vm._v(_vm._s(record.taskName || '-'))]), _c('a-tag', {
      attrs: {
        "color": _vm.getFlowStatusColor(record.status)
      }
    }, [_vm._v(_vm._s(_vm.getFlowStatusText(record.status)))])], 1), _c('div', {
      staticClass: "flow-item-content"
    }, [record.status === null ? _c('p', {
      staticClass: "flow-assignee"
    }, [_c('strong', [_vm._v("等待办理：")]), _vm._v(_vm._s(record.organName || '-') + "-" + _vm._s(record.deptName || '-'))]) : _vm._e(), record.status !== null ? _c('p', {
      staticClass: "flow-assignee"
    }, [_c('strong', [_vm._v("办理部门：")]), _vm._v(_vm._s(record.organName || '-') + "-" + _vm._s(record.deptName || '-'))]) : _vm._e(), _c('p', {
      staticClass: "flow-assignee"
    }, [_c('strong', [_vm._v("接收时间：")]), _vm._v(_vm._s(record.createTime || '-'))]), _c('p', {
      staticClass: "flow-assignee"
    }, [_c('strong', [_vm._v("办理时间：")]), _vm._v(_vm._s(record.finishTime || '-'))]), _c('p', {
      staticClass: "flow-assignee"
    }, [_c('strong', [_vm._v("办理人：")]), _vm._v(_vm._s(record.assigneeName || '-'))]), record.comment ? _c('p', {
      staticClass: "flow-comment"
    }, [_c('strong', [_vm._v("审核意见：")]), _vm._v(_vm._s(_vm.getCommentText(record.comment)))]) : _vm._e(), record.status === null && record.isCandidateUser === true ? _c('a-button', {
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function click($event) {
          return _vm.handleApprove(record);
        }
      }
    }, [_vm._v(" 审批 ")]) : _vm._e()], 1), index < _vm.detail.flowRecords.length - 1 ? _c('div', {
      staticClass: "flow-line"
    }) : _vm._e()]);
  }), !_vm.detail.flowRecords || _vm.detail.flowRecords.length === 0 ? _c('div', {
    staticClass: "no-flow-records"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#999",
      "padding": "20px 0"
    }
  }, [_vm._v("暂无后续流转记录")])]) : _vm._e()], 2)], 1)])]), _c('a-modal', {
    attrs: {
      "title": "审批",
      "confirmLoading": _vm.submitting
    },
    on: {
      "ok": _vm.submitApproval,
      "cancel": _vm.cancelApproval
    },
    model: {
      value: _vm.approvalVisible,
      callback: function callback($$v) {
        _vm.approvalVisible = $$v;
      },
      expression: "approvalVisible"
    }
  }, [_c('a-form', {
    attrs: {
      "model": _vm.approvalForm,
      "layout": "vertical"
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "所属组织及岗位"
    }
  }, [_c('a-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.approvalForm.deptName,
      callback: function callback($$v) {
        _vm.$set(_vm.approvalForm, "deptName", $$v);
      },
      expression: "approvalForm.deptName"
    }
  })], 1), _vm.showAssigneeSelect ? _c('a-form-item', {
    attrs: {
      "label": "指定下一步办理人",
      "required": ""
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择办理人",
      "loading": _vm.assigneeLoading
    },
    model: {
      value: _vm.approvalForm.assigneeId,
      callback: function callback($$v) {
        _vm.$set(_vm.approvalForm, "assigneeId", $$v);
      },
      expression: "approvalForm.assigneeId"
    }
  }, _vm._l(_vm.assigneeList, function (person) {
    return _c('a-select-option', {
      key: person.userId,
      attrs: {
        "value": person.userId
      }
    }, [_vm._v(" " + _vm._s(person.userName) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.showApprovalResult ? _c('a-form-item', {
    attrs: {
      "label": "审批结果",
      "required": ""
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.approvalForm.result,
      callback: function callback($$v) {
        _vm.$set(_vm.approvalForm, "result", $$v);
      },
      expression: "approvalForm.result"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("通过")]), _c('a-radio', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不通过")])], 1)], 1) : _vm._e(), _c('a-form-item', {
    attrs: {
      "label": "审批意见"
    }
  }, [_c('a-textarea', {
    attrs: {
      "rows": 4,
      "placeholder": "请输入审批意见"
    },
    model: {
      value: _vm.approvalForm.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.approvalForm, "comment", $$v);
      },
      expression: "approvalForm.comment"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };